// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pax-form-container {
	background: #e3f0f7;
	border: 1px solid #577481;
	border-radius: 6px;
	padding: 1rem;
}

.pax-new-entry {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
	margin-bottom: 1rem;
}

	.pax-new-entry input[type="text"],
	.pax-new-entry input[type="date"],
	.pax-new-entry select {
		flex: 1 1 140px;
		padding: 6px;
		border-radius: 5px;
		border: 1px solid #ccc;
	}

	.pax-new-entry button {
		padding: 8px 12px;
		background: #0061b0;
		color: white;
		border: none;
		border-radius: 5px;
		cursor: pointer;
		flex: 1 1 120px;
	}

.pax-table {
	width: 100%;
	border-collapse: collapse;
}

	.pax-table th,
	.pax-table td {
		border: 1px solid #577481;
		padding: 8px;
		text-align: left;
	}

	.pax-table th {
		background-color: #577481;
		color: white;
	}

.pax-actions {
	margin-top: 1rem;
	display: flex;
	justify-content: flex-end;
	gap: 12px;
}

	.pax-actions button {
		padding: 8px 16px;
		border-radius: 5px;
		border: none;
		cursor: pointer;
		font-weight: 600;
	}

		.pax-actions button.danger {
			background-color: #dc3545;
			color: white;
		}

		.pax-actions button:not(.danger) {
			background-color: #0061b0;
			color: white;
		}
`, "",{"version":3,"sources":["webpack://./src/pages/demo/forms/PaxForm.css"],"names":[],"mappings":"AAAA;CACC,mBAAmB;CACnB,yBAAyB;CACzB,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,aAAa;CACb,eAAe;CACf,QAAQ;CACR,mBAAmB;AACpB;;CAEC;;;EAGC,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;CACvB;;CAEA;EACC,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;CAChB;;AAED;CACC,WAAW;CACX,yBAAyB;AAC1B;;CAEC;;EAEC,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;CACjB;;CAEA;EACC,yBAAyB;EACzB,YAAY;CACb;;AAED;CACC,gBAAgB;CAChB,aAAa;CACb,yBAAyB;CACzB,SAAS;AACV;;CAEC;EACC,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;CACjB;;EAEC;GACC,yBAAyB;GACzB,YAAY;EACb;;EAEA;GACC,yBAAyB;GACzB,YAAY;EACb","sourcesContent":[".pax-form-container {\n\tbackground: #e3f0f7;\n\tborder: 1px solid #577481;\n\tborder-radius: 6px;\n\tpadding: 1rem;\n}\n\n.pax-new-entry {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tgap: 8px;\n\tmargin-bottom: 1rem;\n}\n\n\t.pax-new-entry input[type=\"text\"],\n\t.pax-new-entry input[type=\"date\"],\n\t.pax-new-entry select {\n\t\tflex: 1 1 140px;\n\t\tpadding: 6px;\n\t\tborder-radius: 5px;\n\t\tborder: 1px solid #ccc;\n\t}\n\n\t.pax-new-entry button {\n\t\tpadding: 8px 12px;\n\t\tbackground: #0061b0;\n\t\tcolor: white;\n\t\tborder: none;\n\t\tborder-radius: 5px;\n\t\tcursor: pointer;\n\t\tflex: 1 1 120px;\n\t}\n\n.pax-table {\n\twidth: 100%;\n\tborder-collapse: collapse;\n}\n\n\t.pax-table th,\n\t.pax-table td {\n\t\tborder: 1px solid #577481;\n\t\tpadding: 8px;\n\t\ttext-align: left;\n\t}\n\n\t.pax-table th {\n\t\tbackground-color: #577481;\n\t\tcolor: white;\n\t}\n\n.pax-actions {\n\tmargin-top: 1rem;\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tgap: 12px;\n}\n\n\t.pax-actions button {\n\t\tpadding: 8px 16px;\n\t\tborder-radius: 5px;\n\t\tborder: none;\n\t\tcursor: pointer;\n\t\tfont-weight: 600;\n\t}\n\n\t\t.pax-actions button.danger {\n\t\t\tbackground-color: #dc3545;\n\t\t\tcolor: white;\n\t\t}\n\n\t\t.pax-actions button:not(.danger) {\n\t\t\tbackground-color: #0061b0;\n\t\t\tcolor: white;\n\t\t}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
